import { render, staticRenderFns } from "./home-type4.vue?vue&type=template&id=34d02cca&scoped=true"
import script from "./home-type4.vue?vue&type=script&lang=js"
export * from "./home-type4.vue?vue&type=script&lang=js"
import style0 from "./home-type4.vue?vue&type=style&index=0&id=34d02cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d02cca",
  null
  
)

export default component.exports